import { render, staticRenderFns } from "./MiniCartList.vue?vue&type=template&id=394c4594&scoped=true"
import script from "./MiniCartList.vue?vue&type=script&lang=js"
export * from "./MiniCartList.vue?vue&type=script&lang=js"
import style0 from "./MiniCartList.vue?vue&type=style&index=0&id=394c4594&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_61f4c95fbe53a3b57a2489edae5a9b2f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394c4594",
  null
  
)

export default component.exports